import { render, staticRenderFns } from "./DeliveryPickup.vue?vue&type=template&id=d0fcb912&lang=pug&"
import script from "./DeliveryPickup.vue?vue&type=script&lang=js&"
export * from "./DeliveryPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports